import React, { useState } from "react";
import { toast } from "sonner";
import { Megaphone, Bell } from "lucide-react";
import { api, formatApiError } from "../../lib/api";
import { H1, Sub } from "./_shared";

export default function BroadcastSection() {
  const [f, setF] = useState({ title: "", body: "", role: "", send_email: false });
  const [last, setLast] = useState(null);
  const [digestBusy, setDigestBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { const { data } = await api.post("/admin/broadcast", { ...f, role: f.role || null }); toast.success(`Sent to ${data.sent} users${data.email_sent ? ` (${data.email_sent} emails)` : ""}`); setLast(data); setF({ title: "", body: "", role: "", send_email: false }); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail) || err.message); }
  };
  const runDigest = async () => {
    if (!window.confirm("Send the city-watch digest to every active watcher whose city has new verified venues since their last digest?")) return;
    setDigestBusy(true);
    try {
      const { data } = await api.post("/admin/watch/digest");
      toast.success(`City-watch digest sent to ${data.sent} watchers (${data.skipped} skipped).`);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail) || err.message); }
    finally { setDigestBusy(false); }
  };
  return (
    <div data-testid="cp-broadcast">
      <H1>Broadcast</H1>
      <Sub>Send an in-app notification to all users or a specific role. Optional email via Resend.</Sub>
      <form onSubmit={submit} className="mt-6 max-w-xl pp-card-elevated p-6 space-y-3">
        <input className="pp-input" required placeholder="Title" value={f.title} onChange={(e) => setF((s) => ({ ...s, title: e.target.value }))} data-testid="cp-bc-title" />
        <textarea className="pp-input" required rows={3} placeholder="Body" value={f.body} onChange={(e) => setF((s) => ({ ...s, body: e.target.value }))} data-testid="cp-bc-body" />
        <select className="pp-input" value={f.role} onChange={(e) => setF((s) => ({ ...s, role: e.target.value }))} data-testid="cp-bc-role">
          <option value="">All users</option>
          <option value="player">Players only</option><option value="coach">Coaches only</option>
          <option value="club_admin">Club admins only</option><option value="federation">Federations only</option>
        </select>
        <label className="flex items-center gap-2 text-sm text-zinc-300">
          <input type="checkbox" checked={f.send_email} onChange={(e) => setF((s) => ({ ...s, send_email: e.target.checked }))} data-testid="cp-bc-email" />
          Also send via email (Resend)
        </label>
        <button data-testid="cp-bc-send" className="pp-btn-primary px-5 py-3 rounded-xl flex items-center gap-2"><Megaphone size={14} /> Send broadcast</button>
        {last && <div className="text-xs text-zinc-500">Last broadcast sent to {last.sent} user(s){last.email_sent ? ` · ${last.email_sent} email(s) delivered` : ""}.</div>}
      </form>

      <div className="mt-10 max-w-xl pp-card-elevated p-6">
        <h3 className="font-heading text-lg font-bold flex items-center gap-2"><Bell size={16} className="text-[#00E676]" /> City-watch digest</h3>
        <p className="text-sm text-zinc-400 mt-2">Email every active watcher the list of verified venues added in their city since their last digest. Idempotent — re-running won't re-send old venues.</p>
        <button
          onClick={runDigest}
          disabled={digestBusy}
          data-testid="cp-watch-digest-run"
          className="pp-btn-primary px-5 py-3 rounded-xl mt-4 disabled:opacity-40"
        >
          {digestBusy ? "Sending…" : "Run city-watch digest"}
        </button>
      </div>
    </div>
  );
}
